import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'filterPipeProviderOrder'
})
export class FilterPipeProviderOrder implements PipeTransform {
    transform(provider_orders: any, term?: any): any {
        if (term === undefined) return provider_orders;
        if (term === null) return provider_orders;

        if (provider_orders != null) {
            return provider_orders.filter(function (provider_order) {
                if (provider_order.created_at != undefined)
                    if (moment(new Date(provider_order.created_at.toDate())).format("DD/MM/YYYY HH:mm").toString().toLowerCase().includes(term.toLowerCase()))
                        return provider_order;
                if (provider_order.provider_static != undefined)
                    if (provider_order.provider_static.toString().toLowerCase().includes(term.toLowerCase()))
                        return provider_order;
                if (provider_order.provider_email != undefined)
                    if (provider_order.provider_email.toString().toLowerCase().includes(term.toLowerCase()))
                        return provider_order;
                if (provider_order.state != undefined) {
                    if (provider_order.state.toString().toLowerCase() == 'send') {
                        var v_send = 'send';
                        if (v_send.includes(term.toLowerCase()))
                            return provider_order;
                    }
                    if (provider_order.state.toString().toLowerCase() == 'received') {
                        var v_received = 'received';
                        if (v_received.includes(term.toLowerCase()))
                            return provider_order;
                    }
                    if (provider_order.state.toString().toLowerCase() == 'completed') {
                        var v_completed = 'completed';
                        if (v_completed.includes(term.toLowerCase()))
                            return provider_order;
                    }
                    if (provider_order.state.toString().toLowerCase() == 'cancelled') {
                        var v_cancelled = 'cancelled';
                        if (v_cancelled.includes(term.toLowerCase()))
                            return provider_order;
                    }
                }
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/providers/orders/provider-order-list/filter.pipe.ts